import React from 'react';

// Styled from index.css only: this renders before the antd theme stylesheet is loaded.
const SplashScreen = () => (
	<div className="splash-screen" role="status" aria-label="Loading">
		<img className="splash-screen__logo" src="/img/logo_colored.png" alt="Arbio" />
		<div className="splash-screen__spinner" />
	</div>
);

export default SplashScreen;
